import { useCallback, useEffect, useState } from 'react';
import {
  fetchMetrics,
  fetchPnl,
  fetchRevenueTrend,
  fetchExpenseBreakdown,
  fetchCashflow,
  fetchGstSummary,
  fetchInsights,
  fetchTransactions,
} from '../api/dashboard';

export function useOverviewDashboard(workspace, { months = 12, expensePeriod } = {}) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState({});

  const load = useCallback(async () => {
    setError(null);
    try {
      const now = new Date();
      const defaultPeriod = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      const period = expensePeriod || defaultPeriod;

      const [
        metrics,
        pnl,
        revenueTrend,
        expenseBreakdown,
        cashflow,
        gstSummary,
        insights,
        transactions,
      ] = await Promise.all([
        fetchMetrics(workspace),
        fetchPnl(workspace, months),
        fetchRevenueTrend(workspace, months),
        fetchExpenseBreakdown(workspace, period),
        fetchCashflow(workspace, Math.min(months, 6)),
        fetchGstSummary(workspace),
        fetchInsights(workspace),
        fetchTransactions(workspace, true),
      ]);

      setData({
        metrics,
        pnl,
        revenueTrend,
        expenseBreakdown,
        cashflow,
        gstSummary,
        insights,
        transactions,
      });
    } catch (e) {
      setError(e.message || 'Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  }, [workspace, months, expensePeriod]);

  useEffect(() => {
    setLoading(true);
    load();
  }, [load]);

  return { loading, error, data, reload: load };
}
